// @ts-nocheck
import React, { useEffect, useState, useRef } from "react";
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import jwt_decode from 'jwt-decode';
import { useCookies } from 'react-cookie';
import { Helmet } from 'react-helmet-async';

import "../css/style.min.css";
import "../css/App.css";

function Login() {
  const [cookies, setCookie, removeCookie] = useCookies(['sessionToken']);
  const [errorMessages, setErrorMessages] = useState("");

  const baseUrl = process.env.REACT_APP_PUBLIC_URL || '';
  const rendered = useRef(false);

  useEffect(() => {
    localStorage.removeItem("urlList");
    console.log("window.google?.accounts?.id", window.google?.accounts?.id);
    localStorage.setItem("windowGoogleAccountsId", window.google?.accounts?.id);

    const checkGSI = () => {
      if (window.google?.accounts?.id) {
        window.google.accounts.id.initialize({
          client_id: process.env.REACT_APP_CLIENT_ID!,
          callback: handleCredentialResponse,
          auto_select: false,
        });
        setTimeout(() => {
          window.google.accounts.id.prompt();
        }, 300);
        console.log("loaded");
      } else {
        console.log("loading...");
        setTimeout(checkGSI, 100);
      }
    };
    checkGSI();
  }, []);

  const handleCredentialResponse = (response: any) => {
    login(response);
  };

  async function login(res) {
    const response = await fetch(process.env.REACT_APP_API_PATH + 'user/login.php?token=' + res.credential);
    const data = await response.json();

    if (data.status === "error") {
      setErrorMessages("ログインに失敗しました");
    } else {
      const decoded = jwt_decode<{ [name: string]: string }>(data);

      setCookie("sessionToken", data, {
        path: '/',
        maxAge: 36000,
      });
      setCookie("userId", decoded.data.USER_ID);
      setCookie("email", decoded.data.EMAIL);
      setCookie("buildingSlug", decoded.data.BUILDING_SLUG);
      setCookie("sectionCodeId1", decoded.data.SECTION_CODE_ID1);

      const url = localStorage.getItem('loginAfterJump');
      if (url !== null) {
        localStorage.removeItem('loginAfterJump');
        window.location.href = url;
      } else {
        window.location.href = baseUrl + "/";
      }
    }
  }

  return (
    <>
      <Helmet>
        <title>Z-link ログイン</title>
      </Helmet>
      <div className="theme-login">
        <div className="login-alert">
          <div className="login-alert-text">
            <p>※Googleにログインしていないと、<br />Z-linkのログイン画面（ポップアップ）は表示されません<br />ログイン後にリロードしてください</p>
          </div>
        </div>
        <div className="contents">
          <div className="login-wrap">
            <div className="login-wrap-main">
              <div className="login-wrap-left">
                <p>Zenkenで働くみんなのよりどころ</p>
                <img
                  src={process.env.PUBLIC_URL + '/logo_positive.svg'}
                  alt="Z-LINK"
                  className="Z-LINK"
                />
                {/* <div className="login-btn">
                  <GoogleOAuthProvider clientId={process.env.REACT_APP_CLIENT_ID}>
                    <GoogleLogin
                      onSuccess={handleCredentialResponse}
                      onError={() => setErrorMessages("ログインに失敗しました")}
                      size="large"
                      text="signin_with"
                      theme="outline"
                    />
                  </GoogleOAuthProvider>
                  {
                    errorMessages !== "" &&
                    <div className="errorMessages">
                      {errorMessages}
                    </div>
                  }
                </div> */}
              </div>
              <div className="corporate-wrap">
                <img
                  className=""
                  src={process.env.PUBLIC_URL + '/year_anniversary_logo.png'}
                />
                <div className="purpose-area">
                  <div className="purpose-text">PURPOSE</div>
                  <span>そこにない未来を創る</span>
                  <div className="purpose-link">
                    <a href="https://www.zenken.co.jp/our-goal/purpose/" target="_blank">詳しく見る</a>
                  </div>
                </div>
                <div className="vision-area">
                  <div className="vision-text">VISION</div>
                  <span>持続可能な社会の創出</span>
                  <div className="vision-link">
                    <a href="https://www.zenken.co.jp/our-goal/vision/" target="_blank">詳しく見る</a>
                  </div>
                </div>
              </div>
            </div>
            <div className="login-help">
              <p className="login-help-main"><a href="https://docs.google.com/presentation/d/13tvJygOoIg_3r_30HF557KZf-JKA5EK0G8y0UPJWmhs/edit?slide=id.g35dc981076c_0_37#slide=id.g35dc981076c_0_37" className="text-link" target="_blank">ログイン方法はこちら</a></p>
              <p className="login-help-sub"><a href="https://docs.google.com/forms/d/e/1FAIpQLSf8J_qCvwGH2VtHBYTznvpzj_gLlwUg1BT5WVAFmrymr69ovQ/viewform" className="text-link sub" target="_blank">ログインできない場合のお問い合わせ</a></p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Login;
